
import { Component, Model, Prop, Vue, Watch } from "vue-property-decorator";
import { BIconPrinter } from "bootstrap-vue";
import { Accordion, AccordionItem } from "@/components/Accordion";
import DocsUpload from "@/components/DocsUpload.vue";
import FamilyDocument from "@/models/Sobrevivencia/BenefactorDocument";
import Benefactor from "@/models/Sobrevivencia/Benefactor";
import SeleccionMetodoPago from "@/components/SeleccionMetodoPago.vue";
import { getBenefactorName,getRespBenefactorName } from "@/utils/HelperFunctions";
import { Action, Getter } from "vuex-class";
@Component({
  components: {
    Accordion,
    AccordionItem,
    DocsUpload,
    BIconPrinter,
    SeleccionMetodoPago,
  },
})
export default class MetodoPago extends Vue {
  @Prop() benefactors: Benefactor[];
  @Prop() estadoAseguradora:string;
  @Getter ("currentBenefactor") currentBenefactor : Benefactor;
  public getBenefactorName = getBenefactorName; 
  public getRespBenefactorName = getRespBenefactorName;
  public paymentMethods = [
    { value: null, text: "Seleccionar" },
    { value: "a", text: "Pago en efectivo por banco BHD" },
  ];
  public notificationChannels = [
    { value: null, text: "Seleccionar" },
    { value: "phone", text: "Celular" },
    { value: "email", text: "Correo electrónico" },
  ];

  @Watch("benefactors")
  public benefactorsChanged(newValue, oldValue) {
    // const requestedBenefactor = parseInt(
    //   this.$route.query.beneficiario as string
    // );
    
    // if(!Number.isNaN(requestedBenefactor)){
    //   if (this.benefactors) {
    //   this.currentBenefactor = this.benefactors.find(
    //     (benefactor) => benefactor.idBeneficiario == requestedBenefactor
    //   );
    // }  
    //   // if (!this.currentBenefactor)
    //   //   this.$router.push("/solicitudes-beneficiario");
    // }else{ 
    //   if (this.benefactors) {
    //   this.currentBenefactor = this.benefactors.find(
    //     (benefactor) => benefactor.esBenefPrincipal == "S"
    //   );
    // }}
  }
}
